import React from "react";
import ReactDOM from "react-dom";
// import { HashRouter as Router } from 'react-router-dom';
import App from "./Components/App/App.jsx";

ReactDOM.render(<App />
    , document.getElementById("root"));